import React, { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Toast } from "../../../CustomComponent/toast";
import performRequest from "../../../api/request";
import StepRoutes from "../../../Routes/steps_routes";
import SimpleButton from "../../../Components/layouts/simple_button";
import Footer from "../../../Components/Footer/footer";
import LoadingPage from "../../../Components/layouts/loading";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../../CustomComponent/custom_error_response";
import { FaStar } from "react-icons/fa";
import { FcCallback } from "react-icons/fc";
function unixToIST(unixTimestamp) {
  // Convert seconds to milliseconds
  const date = new Date(unixTimestamp * 1000);

  // Options for IST formatting
  const options = {
    timeZone: "Asia/Kolkata",
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  // Format date using Intl API
  const formatter = new Intl.DateTimeFormat("en-IN", options);
  return formatter.format(date);
}
function getStatus(status) {
  if (status === 1) {
    return <span className="badge bg-green text-white">Attended</span>;
  } else if (status === 2) {
    return <span className="badge bg-red text-white">Missed</span>;
  } else if (status === 3) {
    return <span className="badge bg-orange text-white">Voicemail</span>;
  } else {
    return "N/A";
  }
}
const ViewMyOpData = () => {
  const [data, setData] = useState();
  let { id } = useParams();
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const [recordings, setRecordings] = useState("");

  useEffect(() => {
    setLoading(true);
    performRequest("GET", `/myOp/getMyOpId/${id}`)
      .then((res) => {
        if (res.status === 200) {
          setData(res.data);
        } else {
          Toast("error", "Error while getting Expense!");
        }
        setLoading(false);
      })
      .catch((err) => {
        CustomErrorResponse(err);
      })
      .finally(() => setLoading(false));
  }, [id]);

  function getRecording(filename) {
    performRequest("GET", `/myOp/getCallRecording/${filename}`)
      .then((res) => {
        if (res.status === 200) {
          setRecordings(res.data);
        } else {
          Toast("error", "Error while getting data!");
        }
      })
      .catch((err) => {
        CustomErrorResponse(err);
      });
  }

  if (loading) {
    return <LoadingPage />;
  }

  return (
    <div className="page">
      <div className="page-wrapper">
        <div className="container-xl">
          <div className="page-header d-print-none">
            <div className="row g-2 align-items-center">
              <div className="col">
                <h2 className="page-title mb-1">  <FcCallback className="fs-2  me-1" /> My Operator Call Log</h2> 
                <h4 className="text-muted">
                  <StepRoutes />
                </h4>
              </div>
            </div>
          </div>
          <div className="card my-4">
            <div className="card-header row g-2 align-items-center">
              <div className="col">
                <h2>View Record</h2>
              </div>
              <div className="col-auto ms-auto d-print-none"></div>
            </div>
            <div className="card-body">
              {data && (
                <>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Caller number
                    </label>
                    <div className="w-100 col">
                      {(data?.caller_number || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      State/Country
                    </label>
                    <div className="w-100 col">
                      {(data?.state || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Call time</label>
                    <div className="w-100 col">
                      {(unixToIST(data?.start_time) || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Duration</label>
                    <div className="w-100 col">
                      {(data?.duration || "N/A").toUpperCase()}
                    </div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">Status</label>
                    <div className="w-100 col">{getStatus(data?.status)}</div>
                  </div>
                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Attended mark
                    </label>
                    <div className="w-100 col">
                      <FaStar
                        fontSize="24px"
                        color={data?.attended ? "orange" : "grey"}
                      />
                    </div>
                  </div>

                  {data?.log_details && data?.log_details.length > 0 && (
                    <div className="mb-3 row">
                      <label className="w-25 form-label col-3">
                        Log Details
                      </label>
                      <div className="w-100 col">
                        {data?.log_details.map((log, index) => (
                          <div
                            key={index}
                            className="mb-2 p-2"
                            style={{
                              border: "1px solid #ccc",
                              borderRadius: "5px",
                            }}
                          >
                            <strong>
                              Received by :{" "}
                              {log.received_by && log.received_by.length > 0
                                ? `${log.received_by[0].name} (${log.received_by[0].contact_number})`
                                : "N/A"}
                            </strong>
                            <br />
                            <em>
                              {log.start_time
                                ? unixToIST(log.start_time)
                                : "N/A"}{" "}
                              <br />
                              Duration : {log.duration || "N/A"}
                              <br />
                              Status : {log.action || "N/A"}
                            </em>
                          </div>
                        ))}
                      </div>
                    </div>
                  )}

                  <div className="mb-3 row">
                    <label className="w-25 form-label col-3">
                      Call Recording
                    </label>
                    <div className="w-100 col">
                      <div className="w-100 my-2">
                        {!recordings && (
                          <button
                            disabled={!data?.filename}
                            className="btn btn-sm btn-primary"
                            onClick={() => getRecording(data?.filename)}
                          >
                            Get recording
                          </button>
                        )}
                        {recordings && (
                          <audio controls style={{ width: "90%" }}>
                            <source src={recordings} type="audio/mpeg" />
                            Your browser does not support the audio element.
                          </audio>
                        )}
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
            <div className="card-footer">
              <div className="btn-list justify-content-end">
                <SimpleButton
                  buttonText="Edit Farm Training"
                  onClick={() => navigate(`/farm-training/edit/${id}`)}
                />
                <SimpleButton buttonText="Cancel" type="secondary" />
              </div>
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default ViewMyOpData;
